/* 2020-09-17
 *langKey 属性名称做为多语言切换依据, langKey的属性值统一第一个大写的字母
 *文本用text做为属性名称
 * */

// 多语言切换更改数据
export const resetTextBylangKey = function (baseData, langData, keyName) {
  const list = JSON.parse(JSON.stringify(baseData));
  list.forEach((item) => {
    if (langData[item.langKey])
      item[keyName || "text"] = langData[item.langKey];
  });
  return list;
};

// 底部tab数据
export const tabbarOptions = [
  {
    langKey: "Home",
    text: "娱乐",
    // icon: 'icon-shouye',
    icon: require("../assets/image/navbar/home.png"),
    iconActive: require("../assets/image/navbar/home_on.png"),
    path: "/home",
  },
  {
    langKey: "Discounts",
    text: "优惠",
    // icon: 'icon-youhui',
    icon: require("../assets/image//navbar/discounts.png"),
    iconActive: require("../assets/image//navbar/discounts_on.png"),
    path: "/discounts",
  },
  {
    langKey: "Texas",
    text: "德州",
    // icon: 'icon-youhui',
    icon: require("../assets/image//navbar/texas.png"),
    iconActive: require("../assets/image//navbar/texas_on.png"),
    path: "/texas",
  },
  {
    langKey: "Deposit",
    text: "存款",
    // icon: 'icon-cunkuan',
    icon: require("../assets/image/navbar/deposit.png"),
    iconActive: require("../assets/image/navbar/deposit_on.png"),
    path: "/funds",
  },
  // {
  //   langKey: "Service",
  //   text: "客服",
  //   // icon: 'icon-kefu',
  //   path: "/Service",
  // },
  {
    langKey: "My",
    text: "我的",
    // icon: 'icon-wode',
    icon: require("../assets/image/navbar/my.png"),
    iconActive: require("../assets/image/navbar/my_on.png"),
    path: "/My",
  },
];

// 首页游戏导航
export const gameNavOptions = [
  {
    langKey: "Slot",
    src1: require("../assets/image/home/gameNav/Slot.png"),
    gameId: "1",
    text: "老虎机",
  },
  {
    langKey: "CatchFish",
    src1: require("../assets/image/home/gameNav/Fish.png"),
    gameId: "5",
    text: "捕鱼",
  },
  {
    langKey: "Sport",
    src1: require("../assets/image/home/gameNav/Sport.png"),
    gameId: "3",
    isESports: "",
    text: "体育",
  },
  {
    langKey: "Live",
    src1: require("../assets/image/home/gameNav/Live.png"),
    gameId: "2",
    text: "真人",
  },
  {
    langKey: "Lottery",
    src1: require("../assets/image/home/gameNav/Lottery.png"),
    gameId: "4",
    text: "彩票",
  },
  {
    langKey: "CardGame",
    src1: require("../assets/image/home/gameNav/CardGame.png"),
    gameId: "6",
    text: "棋牌",
  },

  {
    langKey: "Esport",
    src1: require("../assets/image/home/gameNav/Esport.png"),
    gameId: "3",
    isESports: "1",
    text: "电竞",
  },
];

// 客服列表
export const serviceOptions = [
  {
    langKey: "live_chat",
    text: "在线客服",
    icon: require("../assets/image/Service/livechat.png"),
    links: "",
  },
  // {
  //   langKey: "whatsapp",
  //   text: "Whatsapp",
  //   icon: require("../assets/image/Service/whatsapp.png"),
  //   links: "",
  // },
  {
    langKey: "telegram",
    text: "Telegram",
    icon: require("../assets/image/Service/telegram.png"),
    links: "",
  },
  // {
  //   langKey: "commonProblem",
  //   text: "常见问题",
  //   icon: require("../assets/image/Service/bulb.png"),
  //   links: "/Service/Problems",
  // },
];

// 客服常见问题(未使用)
export const serviceProblemOptions = [
  {
    langKey: "aboutUs",
    text: "关于我们",
    icon: require("../assets/image/Service/livechat.png"),
    links: "/Service/Problems/Weabout",
  },
  {
    langKey: "commonProblem",
    text: "常见问题",
    icon: require("../assets/image/Service/whatsapp.png"),
    links: "",
  },
  {
    langKey: "connectUs",
    text: "联系我们",
    icon: require("../assets/image/Service/telegram.png"),
    links: "",
  },
  {
    langKey: "serviceTerms",
    text: "服务条款",
    icon: require("../assets/image/Service/bulb.png"),
    links: "",
  },
  {
    langKey: "privacyPolicy",
    text: "隐私条款",
    icon: require("../assets/image/Service/bulb.png"),
    links: "",
  },
  {
    langKey: "disclaimer",
    text: "免责声明",
    icon: require("../assets/image/Service/bulb.png"),
    links: "",
  },
  {
    langKey: "dutyLottery",
    text: "责任博彩",
    icon: require("../assets/image/Service/bulb.png"),
    links: "",
  },
];

// 优惠详情会员信息
export const discountUserInfoOptions = [
  {
    text: "会员账号",
    langKey: "userAccount",
    val: "",
  },
  {
    text: "当前等级",
    langKey: "levelInfo",
    val: "",
  },
  {
    text: "累积投注额",
    langKey: "totalBetflow",
    val: "",
  },
  {
    text: "累积晋级彩金",
    langKey: "totalUpAmount",
    val: "",
  },
  {
    text: "累积周俸禄彩金",
    langKey: "totalWeekAmount",
    val: "",
  },
  {
    text: "累积月俸禄彩金",
    langKey: "totalMonthAmount",
    val: "",
  },
  {
    text: "晋级投注额",
    langKey: "nextLevelBetflow",
    val: "",
  },
];

// 我的 列表1
export const minBaseOptions1 = [
  {
    langKey: "SaveMonery",
    text: "存款",
    imageSrc: require("../assets/image/My/ck.png"),
    path: "/SaveMonery",
  },
  {
    langKey: "Withdrawal",
    text: "取款",
    imageSrc: require("../assets/image/My/qk.png"),
    path: "/My/Withdrawal",
  },
  {
    langKey: "Wallet",
    text: "钱包",
    imageSrc: require("../assets/image/My/qb.png"),
    path: "/My/Wallet",
  },
  {
    langKey: "StationLetter",
    text: "站内信",
    imageSrc: require("../assets/image/My/znx.png"),
    path: "/My/StationLetter",
  },
];

// 我的 列表2
export const minBaseOptions2 = [
  {
    langKey: "betRecord",
    text: "投注记录",
    imageSrc: require("../assets/image/My/tz.png"),
    path: "/My/bet-record",
  },
  {
    langKey: "merchRecord",
    text: "交易记录",
    imageSrc: require("../assets/image/My/tk.png"),
    path: "/My/merch-record",
  },
  // {
  //   langKey: 'Yeahpay',
  //   text: '余额宝',
  //   imageSrc: require('../assets/image/My/Yeahpay.png'),
  //   path: '/activity-yuebao'
  // },
  // 暂时不加
  // {
  //   langKey: 'latestDeposit',
  //   text: '存款订单记录',
  //   imageSrc: require('../assets/image/My/tk.png'),
  //   path: '/My/latest-deposit'
  // },
  {
    langKey: "lockAmount",
    text: "资金锁定明细",
    imageSrc: require("../assets/image/My/zj.png"),
    path: "/My/lock-amount",
  },
  {
    langKey: "InviteFriends",
    text: "邀请好友",
    imageSrc: require("../assets/image/My/yq.png"),
    path: "/My/InviteFriends",
  },
  {
    langKey: "agentCenter",
    text: "代理中心",
    imageSrc: require("../assets/image/My/zhgl_hync.png"),
    path: "",
  },
  {
    langKey: "appDownload",
    text: "APP下载",
    imageSrc: require("../assets/image/My/sj.png"),
    path: "",
  },
];

// 站内信 外层tab
export const StationLetterTabOptions = [
  {
    text: "我的消息",
    langKey: "myMessage",
  },
  {
    text: "发送新消息",
    langKey: "sendMessage",
  },
];

// 站内信 我的消息tab
export const myMsgTabOptions = [
  {
    text: "最新消息",
    val: 0,
    langKey: "unread",
  },
  {
    text: "已读消息",
    val: 1,
    langKey: "read",
  },
];

export const msgTypeOptions = [
  {
    text: "存取款问题",
    value: "0",
    langKey: "money",
  },
  {
    text: "优惠活动",
    value: "1",
    langKey: "discounts",
  },
  {
    text: "游戏问题",
    value: "2",
    langKey: "games",
  },
  {
    text: "其它问题",
    value: "3",
    langKey: "other",
  },
  {
    text: "建议",
    value: "4",
    langKey: "proposal",
  },
  {
    text: "投诉",
    value: "5",
    langKey: "complaint",
  },
];

// 交易记录
export const tradingTypeOptions = [
  {
    text: "全部",
    langKey: 0,
  },
  {
    text: "系统调帐",
    langKey: 1,
  },
  {
    text: "充值存款",
    langKey: 2,
  },
  {
    text: "秒速提款",
    langKey: 3,
  },
  {
    text: "转入游戏",
    langKey: 4,
  },
  {
    text: "游戏转出",
    langKey: 5,
  },
  {
    text: "优惠红利",
    langKey: 8,
  },
  {
    text: "人工存入",
    langKey: 9,
  },
  {
    text: "人工取出",
    langKey: 10,
  },
  {
    text: "投注",
    langKey: 40,
  },
  {
    text: "派彩",
    langKey: 41,
  },
  {
    text: "申请中",
    langKey: 100,
  },
];

// 我的 -- 资金锁定明细 -- 优惠锁定
// 部分平台数据
export const platformPartOptions = [
  // 平台部分数据
  {
    name: "全部平台",
    value: "",
    langKey: "all",
  },
  {
    name: "主账户",
    value: "-1",
    langKey: "main",
  },
];

// 红利类型
export const bonusTypeOptions = [
  {
    value: "",
    name: "全部类型",
    langKey: "all",
  },
  {
    value: "1",
    name: "流水返利",
    langKey: "waterRebate",
  },
  {
    value: "2",
    name: "存款优惠",
    langKey: "softLoan",
  },
  {
    value: "A",
    name: "救援金",
    langKey: "rescueGold",
  },
  {
    value: "B",
    name: "VIP升级奖励",
    langKey: "upgradeAwards",
  },
  {
    value: "C",
    name: "VIP蝉联奖励",
    langKey: "winAwards",
  },
  {
    value: "5",
    name: "其他优惠",
    langKey: "otherPreferential",
  },
  {
    value: "7",
    name: "注册优惠",
    langKey: "joinPreferential",
  },
];

export const dateSelectedOptions = [
  {
    langKey: "90",
    text: "全部",
  },
  {
    langKey: "1",
    text: "24小时",
  },
  {
    langKey: "7",
    text: "7日",
  },
  {
    langKey: "30",
    text: "1个月",
  },
];

// 第三方登录
export const thirdPartyLoginOptions = [
  {
    langKey: "Google",
    imgSrc: require("../assets/image/common/icon_google.png"),
    text: "谷歌",
  },
  {
    langKey: "Facebook",
    imgSrc: require("../assets/image/common/icon_facebook.png"),
    text: "脸书",
  },
  // {
  //   langKey: 'Twitter',
  //   imgSrc: require('../assets/image/common/icon_twitter.png'),
  //   text: '推特'
  // }
];

// 账户管理
export const manageOptions = [
  {
    text: "会员昵称",
    imgSrc: require("../assets/image/My/zhgl_hync.png"),
    value: "",
    langKey: "nickName",
  },
  {
    text: "真实姓名",
    imgSrc: require("../assets/image/My/zhgl_zsxm.png"),
    path: "/My/AccountManat/VerifiedAuth",
    value: "去认证",
    langKey: "name",
    langKey2: "authe",
    Valid: "nameValid",
    tipsKey: "name",
  },
  {
    text: "手机号码",
    imgSrc: require("../assets/image/My/zhgl_sjh.png"),
    path: "/My/AccountManat/mobileAuth",
    value: "去认证",
    langKey: "phone",
    langKey2: "authe",
    Valid: "mobileValid",
    tipsKey: "phone",
  },
  {
    text: "邮箱",
    imgSrc: require("../assets/image/My/zhgl_yx.png"),
    path: "/My/AccountManat/emailAuth",
    value: "去认证",
    langKey: "email",
    langKey2: "authe",
    Valid: "emailValid",
    tipsKey: "email",
  },
  {
    text: "登录密码",
    imgSrc: require("../assets/image/My/zhgl_dlmm.png"),
    path: "/My/AccountManat/loginPossword",
    value: "修改",
    langKey: "loginPwd",
    langKey2: "edit",
  },
  {
    text: "提款密码",
    imgSrc: require("../assets/image/My/zhgl_tkmm.png"),
    path: "/My/AccountManat/WithdrawPasword",
    value: "设置",
    langKey: "drawPws",
    langKey2: "setting",
  },
];



// WEBPACK FOOTER //
// ./src/pages/build800/libs/options.js